/* eslint-disable */
/*
  original version: 2.6.5
  latest referenced version: 2.8.4
*/
import prodPathReplace from '../../shared/prod-path-rewrite';

(function (factory) {
  factory(window.jQuery);
}(($) => {
  $.extend($.FE.POPUP_TEMPLATES, {
    'colors.picker': '[_BACKGROUND_COLORS_][_TEXT_COLORS_]',
  });

  // Extend defaults.
  $.extend($.FE.DEFAULTS, {
    colorsText: [
      '#4F980C', '#EB0C3B', '#1E9FD6', '#97CED4', '#FA6625', '#FFD000',
      '#FFFFFF', '#E4E7EC', '#ACB5C2', '#748499', '#576373', '#1D2126',
    ],
    colorsBackground: [
      '#FFF6D0', '#D8F0FA', '#E1F1D3', '#FFE2D5', '#FFFFFF', '#3A424D',
    ],
    colorsStep: 6,
    defaultTextColor: '#1D2126',
    defaultBackgroundColor: '#FFFFFF',
  });

  $.FE.PLUGINS.colors = function (editor) {
    /*
     * Show the colors popup.
     */
    function _showColorsPopup() {
      const $btn = editor.$tb.find('.fr-command[data-cmd="color"]');

      let $popup = editor.popups.get('colors.picker');

      if (!$popup) {
        $popup = _initColorsPopup();
      }

      if (!$popup.hasClass('fr-active')) {
        // Colors popup
        editor.popups.setContainer('colors.picker', editor.$tb);

        // Refresh selected color.
        _refreshColor('text');
        _refreshColor('background');

        // Colors popup left and top position.
        if ($btn.is(':visible')) {
          const left = $btn.offset().left + $btn.outerWidth() / 2;
          const top = $btn.offset().top + (editor.opts.toolbarBottom ? 10 : $btn.outerHeight() - 10);
          editor.popups.show('colors.picker', left, top, $btn.outerHeight());
        } else {
          editor.position.forSelection($popup);
          editor.popups.show('colors.picker');
        }
      }
    }

    /*
     * Hide colors popup.
     */
    function _hideColorsPopup() {
      // Hide popup.
      editor.popups.hide('colors.picker');
    }

    /**
     * Init the colors popup.
     */
    function _initColorsPopup() {
      const template = {
        /* eslint-disable camelcase */
        text_colors: _colorPickerHTML('text'),
        background_colors: _colorPickerHTML('background'),
      };

      // Create popup.
      const $popup = editor.popups.create('colors.picker', template);

      _addAccessibility($popup);

      return $popup;
    }

    /*
     * HTML for the color picker colors.
     */
    function _colorPickerHTML(tab) {
      // Get colors according to tab name.
      const colors = (tab === 'text' ? editor.opts.colorsText : editor.opts.colorsBackground);

      // Create colors html.
      let colorsHtml = `<div class="fr-color-set fr-${tab}-color fr-selected-set">`;
      colorsHtml += `<div class="color-header">
        ${tab === 'text' ? editor.language.translate('Text Color') : editor.language.translate('Highlight Color')}</div>`;

      // Add colors.
      for (let i = 0; i < colors.length; i += 1) {
        if (i !== 0 && i % editor.opts.colorsStep === 0) {
          colorsHtml += '<br>';
        }

        colorsHtml += `<span class="fr-command fr-select-color ${tab === 'text' && colors[i] === '#FFFFFF' ? 'outline' : ''}"
          style="background: ${colors[i]};"
          tabIndex="0"
          aria-selected="false"
          role="button"
          data-cmd="${tab}Color"
          data-param1="${colors[i]}">
            <span class="fr-sr-only">
              ${editor.language.translate('Color')} ${colors[i]}&nbsp;&nbsp;&nbsp;
            </span>
          </span>`;
      }

      return `${colorsHtml}</div>`;
    }

    /*
     * Register keyboard events.
     */
    function _addAccessibility($popup) {
      // Register popup event.
      editor.events.on('popup.tab', (e) => {
        const $focusedItem = $(e.currentTarget);

        // Skip if popup is not visible or focus is elsewere.
        if (!editor.popups.isVisible('colors.picker') || !$focusedItem.is('span')) {
          return true;
        }
        const keyCode = e.which;
        let status = true;

        // Tabbing.
        if ($.FE.KEYCODE.TAB === keyCode) {
          const $tb = $popup.find('.fr-buttons');

          // Focus back the popup's toolbar if exists.
          status = !editor.accessibility.focusToolbar($tb, (!!e.shiftKey));
        }

        // Arrows.
        else if ($.FE.KEYCODE.ARROW_UP === keyCode || $.FE.KEYCODE.ARROW_DOWN === keyCode || $.FE.KEYCODE.ARROW_LEFT === keyCode || $.FE.KEYCODE.ARROW_RIGHT === keyCode) {
          if ($focusedItem.is('span.fr-select-color')) {
            // Get all current colors.
            const $colors = $focusedItem.parent().find('span.fr-select-color');

            // Get focused item position.
            const index = $colors.index($focusedItem);

            // Get color matrix dimensions.
            const columns = editor.opts.colorsStep;
            const lines = Math.floor($colors.length / columns);

            // Get focused item coordinates.
            const column = index % columns;
            const line = Math.floor(index / columns);

            let nextIndex = line * columns + column;
            const dimension = lines * columns;

            // Calculate next index. Go to the other opposite site of the matrix if there is no next adjacent element.
            // Up/Down: Traverse matrix lines.
            // Left/Right: Traverse the matrix as it is a vector.
            if ($.FE.KEYCODE.ARROW_UP === keyCode) {
              nextIndex = (((nextIndex - columns) % dimension) + dimension) % dimension; // Javascript negative modulo bug.
            } else if ($.FE.KEYCODE.ARROW_DOWN === keyCode) {
              nextIndex = (nextIndex + columns) % dimension;
            } else if ($.FE.KEYCODE.ARROW_LEFT === keyCode) {
              nextIndex = (((nextIndex - 1) % dimension) + dimension) % dimension; // Javascript negative modulo bug.
            } else if ($.FE.KEYCODE.ARROW_RIGHT === keyCode) {
              nextIndex = (nextIndex + 1) % dimension;
            }

            // Get the next element based on the new index.
            const $el = $($colors.get(nextIndex));

            // Focus.
            editor.events.disableBlur();
            $el.focus();

            status = false;
          }
        }

        // ENTER or SPACE.
        else if ($.FE.KEYCODE.ENTER === keyCode) {
          editor.button.exec($focusedItem);
          status = false;
        }

        // Prevent propagation.
        if (status === false) {
          e.preventDefault();
          e.stopPropagation();
        }

        return status;
      }, true);
    }

    /*
     * Show the current selected color.
     */
    function _refreshColor(tab) {
      const $popup = editor.popups.get('colors.picker');
      let $element = $(editor.selection.element());

      // The color css property.
      let colorType;
      let $selectColor;

      if (tab === 'background') {
        colorType = 'background-color';
      } else {
        colorType = 'color';
      }

      const $currentColor = $popup.find(`.fr-${tab}-color .fr-select-color`);

      // Remove current color selection.
      $currentColor.find('.fr-selected-color').remove();
      $currentColor.removeClass('fr-active-item');
      $currentColor.attr('aria-selected', false);

      // Find the selected color.
      if ($element.get(0) !== editor.el) {
        while (true) {
          // Transparent
          if (tab === 'background' && ($element.css(colorType) === 'transparent' || $element.css(colorType) === 'rgba(0, 0, 0, 0)')) {
            const $tempElement = $element.parent();

            if ($tempElement.get(0) !== editor.el) {
              $element = $tempElement;
            } else {
              $selectColor = $popup.find(`.fr-${tab}-color .fr-select-color[data-param1="${editor.opts.defaultBackgroundColor}"]`);
              break;
            }
          } else {
            $selectColor = $popup.find(`.fr-${tab}-color .fr-select-color[data-param1="${editor.helpers.RGBToHex($element.css(colorType))}"]`);
            break;
          }
        }
      }


      $selectColor.append('<span class="fr-selected-color" aria-hidden="true"></span>');
      $selectColor.addClass('fr-active-item').attr('aria-selected', true);
    }

    /*
     * Change background color.
     */
    function background(val) {
      const $popup = editor.popups.get('colors.picker');
      const $currentSelectedColor = $popup.find('.fr-background-color .fr-select-color .fr-selected-color');

      if (val === $currentSelectedColor.parent().data('param1') || val === editor.opts.defaultBackgroundColor) {
        editor.format.removeStyle('background-color');
      } else {
        editor.format.applyStyle('background-color', editor.helpers.HEXtoRGB(val));
      }

      // _hideColorsPopup();
      _refreshColor('background');
    }

    /*
     * Change text color.
     */
    function text(val) {
      const $popup = editor.popups.get('colors.picker');
      const $currentSelectedColor = $popup.find('.fr-text-color .fr-select-color .fr-selected-color');

      if (val === $currentSelectedColor.parent().data('param1') || val === editor.opts.defaultTextColor) {
        editor.format.removeStyle('color');
      } else {
        editor.format.applyStyle('color', editor.helpers.HEXtoRGB(val));
      }

      // _hideColorsPopup();
      _refreshColor('text');
    }

    return {
      showColorsPopup: _showColorsPopup,
      hideColorsPopup: _hideColorsPopup,
      background,
      text,
    };
  };

  // Toolbar colors button.
  $.FE.RegisterCommand('color', {
    title: 'Colors',
    undo: false,
    focus: true,
    refreshOnCallback: false,
    popup: true,
    callback() {
      if (!this.popups.isVisible('colors.picker')) {
        this.colors.showColorsPopup();
      } else {
        if (this.$el.find('.fr-marker').length) {
          this.events.disableBlur();
          this.selection.restore();
        }
        this.popups.hide('colors.picker');
      }
    },
    plugin: 'colors',
  });

  // Select text color command.
  $.FE.RegisterCommand('textColor', {
    undo: true,
    callback(cmd, val) {
      this.colors.text(val);
    },
  });

  // Select background color command.
  $.FE.RegisterCommand('backgroundColor', {
    undo: true,
    callback(cmd, val) {
      this.colors.background(val);
    },
  });

  const colorIconSrc = prodPathReplace('images/icon-colorpicker.png');

  $.FroalaEditor.DefineIcon('color', { SRC: colorIconSrc, ALT: 'color picture button', template: 'image' });
}));
